import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../lib/axios";

export default function TransmittalList() {
  const [data, setData] = useState([]);
  const [months, setMonths] = useState([]);
  const [projects, setProjects] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedProject, setSelectedProject] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    async function loadTransmittals() {
      try {
        const monthRes = await axiosInstance.get("/transmittal/month-list");
        const monthList = Array.isArray(monthRes.data) ? monthRes.data : [];

        setMonths(monthList);

        const now = new Date();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        const key = `${thisMonth}-${thisYear}`;

        const exists = monthList.some(
          (m) =>
            Number(m?._id?.month) === thisMonth &&
            Number(m?._id?.year) === thisYear,
        );

        if (exists) setSelectedMonth(key);

        const dataRes = await axiosInstance.get("/transmittal/monthwise");
        const monthData = Array.isArray(dataRes.data) ? dataRes.data : [];

        setData(monthData);

        const projSet = new Set();

        monthData.forEach((group) => {
          const transmittals = Array.isArray(group.transmittals)
            ? group.transmittals
            : [];

          transmittals.forEach((t) => {
            if (t.projectName) projSet.add(t.projectName);
          });
        });

        setProjects([...projSet]);
      } catch (err) {
        console.log(
          "Transmittal list fetch error:",
          err.response?.data || err.message,
        );
        setMonths([]);
        setData([]);
        setProjects([]);
      }
    }

    loadTransmittals();
  }, []);

  const filterTransmittals = () => {
    let result = [];

    data.forEach((group) => {
      const month = Number(group?._id?.month);
      const year = Number(group?._id?.year);
      const monthKey = `${month}-${year}`;

      if (selectedMonth && selectedMonth !== monthKey) return;

      const transmittals = Array.isArray(group.transmittals)
        ? group.transmittals
        : [];

      transmittals.forEach((t) => {
        if (selectedProject && t.projectName !== selectedProject) return;

        result.push({
          ...t,
          month,
          year,
        });
      });
    });

    return result;
  };

  const filtered = filterTransmittals();

  const getDocNames = (rows = []) =>
    Array.isArray(rows)
      ? rows
          .map((r) => r.name)
          .filter(Boolean)
          .join(", ")
      : "";

  const getDocTypes = (rows = []) =>
    Array.isArray(rows)
      ? rows
          .map((r) => r.type)
          .filter(Boolean)
          .join(", ")
      : "";

  return (
    <div style={{ padding: "20px" }}>
      <h2>📄 Transmittal Records</h2>

      <button onClick={() => navigate("/transmittal")} style={backBtn}>
        ⬅ Back
      </button>

      <div
        style={{
          display: "flex",
          gap: "20px",
          margin: "15px 0",
          alignItems: "center",
        }}
      >
        <div>
          <label>
            <b>Select Month:</b>
          </label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            style={selectStyle}
          >
            <option value="">All Months</option>

            {months.map((m, i) => {
              const month = Number(m?._id?.month);
              const year = Number(m?._id?.year);

              return (
                <option key={i} value={`${month}-${year}`}>
                  {new Date(year, month - 1).toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </option>
              );
            })}
          </select>
        </div>

        <div>
          <label>
            <b>Select Project:</b>
          </label>
          <select
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.target.value)}
            style={selectStyle}
          >
            <option value="">All Projects</option>

            {projects.map((p, i) => (
              <option key={i} value={p}>
                {p}
              </option>
            ))}
          </select>
        </div>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#E4E8FF" }}>
            <th style={cell}>Month</th>
            <th style={cell}>Trans No</th>
            <th style={cell}>Project Name</th>
            <th style={cell}>Document Name</th>
            <th style={cell}>Type</th>
            <th style={cell}>Prepared By</th>
            <th style={cell}>Date</th>
          </tr>
        </thead>

        <tbody>
          {filtered.length === 0 ? (
            <tr>
              <td style={cell} colSpan={7}>
                No records found.
              </td>
            </tr>
          ) : (
            filtered.map((t) => (
              <tr
                key={t._id}
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/transmittal/${t._id}`)}
              >
                <td style={cell}>
                  {new Date(t.year, t.month - 1).toLocaleString("default", {
                    month: "short",
                    year: "numeric",
                  })}
                </td>

                <td style={cell}>{t.transNo}</td>
                <td style={cell}>{t.projectName}</td>
                <td style={cell}>{getDocNames(t.rows)}</td>
                <td style={cell}>{getDocTypes(t.rows)}</td>
                <td style={cell}>{t.preparedBy}</td>
                <td style={cell}>{t.date}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

const cell = {
  border: "1px solid #ccc",
  padding: "8px",
  textAlign: "center",
};

const selectStyle = {
  padding: "8px",
  borderRadius: "6px",
  border: "1px solid #999",
  minWidth: "150px",
};

const backBtn = {
  padding: "6px 14px",
  background: "#444",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "15px",
};
